import React from "react";

export default function AgentAvatar({ className = "" }: { className?: string }) {
  return (
    <div
      className={`w-7 h-7 rounded-full flex items-center justify-center shrink-0 ${className}`}
      style={{ background: "linear-gradient(135deg, var(--c-primary), var(--c-info))" }}
    >
      <svg width="14" height="14" viewBox="0 0 14 14" fill="none" stroke="white" strokeWidth="1.5">
        <circle cx="7" cy="5" r="2.5" />
        <path d="M3 12c0-2.2 1.8-4 4-4s4 1.8 4 4" />
      </svg>
    </div>
  );
}
